import { useEffect, useRef } from 'react';
import Checkbox from '../../../components/inputs/Checkbox';
import Input from '../../../components/inputs/Input';
import { EmployeePutRequest } from '../../../types/employee/EmployeePutRequest';
import { focusNextInput } from '../../../utils/focusNextInput';
import SubmitAndCancelButton from '../../../components/button/SubmitAndCancelButton';

interface EditEmployeeRowProps {
  item: EmployeePutRequest;
  onChange: (key: keyof EmployeePutRequest, value: any) => void;
  onEditSubmitButtonClick: (id: number) => void;
  onEditCancelButtonClick: () => void;
}

const EditEmployeeRow: React.FC<EditEmployeeRowProps> = ({
  item,
  onChange,
  onEditSubmitButtonClick,
  onEditCancelButtonClick,
}) => {
  const inputsRef = useRef<(HTMLInputElement | HTMLButtonElement)[]>([]);

  // 最初の input に自動フォーカス
  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  return (
    <>
      <td>
        <Input
          value={item.employeeCode}
          onChange={(e) => onChange('employeeCode', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 0)}
        />
      </td>
      <td>
        <Input
          value={item.name}
          onChange={(e) => onChange('name', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 1)}
        />
      </td>
      <td>
        <Input
          value={item.password}
          onChange={(e) => onChange('password', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 2)}
        />
      </td>
      <td>
        <Checkbox
          checked={item.isDairen}
          onChange={(checked) => onChange('isDairen', checked)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 3)}
        />
      </td>
      <td>
        <Checkbox
          checked={item.isAdmin}
          onChange={(checked) => onChange('isAdmin', checked)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 4)}
        />
      </td>
      <td className="text-center">
        <SubmitAndCancelButton
          onSubmit={() => onEditSubmitButtonClick(item.id)}
          onCancel={() => onEditCancelButtonClick()}
          onSubmitKeyDown={(e) => focusNextInput(e, inputsRef, 9)}
          onCancelKeyDown={(e) => focusNextInput(e, inputsRef, 10)}
          submitButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          cancelButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
        />
      </td>
    </>
  );
};

export default EditEmployeeRow;
